import { render, staticRenderFns } from "./ProductsTypes.vue?vue&type=template&id=7415c4fb"
import script from "./ProductsTypes.vue?vue&type=script&lang=js"
export * from "./ProductsTypes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports